import React, { Component, Fragment } from 'react';
import { Table,Image } from "semantic-ui-react";
import {Button, Icon, Message, Modal, Form,Checkbox,Dropdown,TextArea,Breadcrumb,Input} from "semantic-ui-react"
import DayPickerInput from "react-day-picker/DayPickerInput"
import shop from "shop/shop"
import {Row, Col, FormField, FormInput} from "elemental-react16"
import _ from "lodash"
import productStore from "stores/productStore"
import ordinals from "theme/arnoldsports/sortParamsVariant"
import moment                               from "moment"
import Spinner                              from "components/Spinner/Spinner"
import SuccessTable                         from "components/Product/SuccessTableReturn"
import { Redirect } from "react-router"
import { Link, withRouter } from "react-router-dom"
import Responsive from "react-responsive"
import { observer } from "mobx-react"
import DeliveryDatePicker from "components/Date/DeliveryDatePicker"

@withRouter
@observer
class ReturnAdminPage extends Component {
    state = {
        inventory: false,
        inventoryOrder: [],
        byId: {},
        loading: false,
        showContact: false,
        loadingDelivery: false,
        notFoundPositions: [],
        adminInterface: false, 
        customers: [],
        customerSearch: [],
        saved: false,
        searchString: "",
        searchResult: [],
        modalOpen: false,
        modalOpenSingle: false,
        idToDelete: "",
        showAll: false,
        newSeason: {
            season: {
                start: "",
                activeSaison: "",
                id: "",
            },
            seasons: {}
        },
    };

    componentDidMount() {
        if(!shop.session){
            console.log("!shop.session")
            this.props.history.push("/login")
          }
        if(!shop.session.handuser || shop.session.handId ){
            this.setState({adminInterface: true})
            this.handleLoadCustomers();
        }
        this.handleFetchSaison();
        //this.handleLoadInventory();
        //this.handleLoadDelivery();
    }


    handleFetchSaison = async () => {
      console.log("DATA handleFetchSaison")
      try {
      const response = await shop.fetch('/shop/rest/config/?set=' + encodeURIComponent(JSON.stringify(["web.kv.id","web.kv.saison","web.kv.active","web.kv.year","web.kv.end"])), {
        method: 'GET',
        credentials: 'include'
      });
      console.log("DATA: ", response);
      const data = await response
      const active = data["web.kv.active"].split(",");
      const names = decodeURIComponent(data["web.kv.saison"]).split(",");
      let Ids = [];
      if (data["web.kv.id"]) {
        Ids = data["web.kv.id"].split(",");
      } else if (data["web.kv.saison"]) {
        const saison = decodeURIComponent(data["web.kv.saison"]);
        Ids = saison.split(",").map(s => (s.length >= 2 ? s[0] + s.slice(-2) : s));
      }
      let years = [];
      if (data["web.kv.year"]) {
        years = data["web.kv.year"].split(",");
      }
      let ends = [];
      if (data["web.kv.end"]) {
        ends = data["web.kv.end"].split(",");
      }
      console.log("DATA PARSED: ", names, active, Ids, years, ends);
      const seasons = {};
      for (let i = 0; i < names.length; i++) {
        if (active[i] !== "" && names[i] !== "") {
          seasons[names[i]] = {
        active: active[i],
        name: names[i],
        id: Ids[i] ? Ids[i] : "",
        year: years[i] ? years[i] : "",
        end: ends[i] ? ends[i] : "",
          };
        }
      }
      await this.setState({
        newSeason: {
          season: {
        active: "",
        name: "",
        id: "",
          },
          seasons: seasons
        }
      });
      console.log("DATA POST: ", this.state.newSeason);
      await this.setState({saved: true});
      } catch (error) {
      console.error('Error fetching saison:', error);
      }
    }



    handleLoadCustomers = async () => {
        console.log("handleLoadCustomers")
        try {
            let start = 0;
            let count = 200;
            let inventory = [];
            let response = null;
            this.setState({ loading: true });
            do {
                response = await shop.fetch(`/shop/rest/data/orders?start=${start}&count=${count}&status=[0%2C1%2C2%2C3]`, {
                    method: "GET",
                    credentials: "include",
                });
                inventory = inventory.concat(response);
                //start += 200;
                //count += 200;
            } while (count !== 200); //response.size >= count
            // process the loaded inventory data
            //console.log("WHOLE INVENTORY PRE: ",inventory);
            let allCustomers = [];
            for (let i = 0; i < inventory.length; i++) {
              allCustomers = allCustomers.concat(inventory[i].values);
            }
            console.log("ALL CUSTOMERS: ", allCustomers);
            //const uniqueCustomers = _.uniqBy(allCustomers, 'map_id');
            const uniqueCustomers = allCustomers;
            console.log("UNIQUE CUSTOMERS: ", uniqueCustomers);
            uniqueCustomers.sort((a, b) => b.customer.title.localeCompare(a.customer.title));
            this.setState({ customers: uniqueCustomers, loading: false });
            this.setState({customerSearch: this.state.customers});

            console.log("UPDATED CUSTOMERS: ", this.state.customers);
        } catch (error) {
            console.error(error);
        }
    }

    render() {
        let { size, customerId, customers, loadingRestore, loading,saved, searchResult, customerSearch, modalOpen, modalOpenSingle,idToDelete, showAll, weihnachten, ostern, herbst, newSeason } = this.state
        const useMore = size > customers.length
        //console.log("CUSTOMERS: ", customers, customerSearch)

        if(!shop.session){
            console.log("!shop.session")
            this.props.history.push("/login")
            document.location.reload()
            return null
        }
        let { product, categoryId = "" } = this.props

        
        const handleSearchCustomer = async (event) => {
          console.log("SEARCH CUSTOMER: ", event.target.value, this.state.selectedSeasons)
          this.setState({searchString: event.target.value});
          if(event.target.value.length > 3 || (this.state.selectedSeasons && this.state.selectedSeasons.length) > 0){
            console.log("SEARCH CUSTOMER: ", event.target.value)
            let response = null
            try {
              let queryString = `/shop/rest/data/orders?start=0&count=200&status=[0%2C1%2C2%2C3]&filter=[{"field":"customerId","op":"like","value":"${event.target.value}%25"}]`;
              console.log("QUERY STRING: ", queryString, this.state.selectedSeasons.length, this.state.selectedSeasons)
              if(this.state.selectedSeasons && this.state.selectedSeasons.length > 0) {
                console.log("SELECTED SEASON: ", this.state.selectedSeasons)
                queryString += `&extras=%7B"bausteinSeason":"${this.state.selectedSeasons}"%7D`;
              }
              response = await shop.fetch(queryString, {
                method: "GET",
                credentials: "include",
              });
              console.log("RESPONSE: ", response.values);

              this.setState({ customers: response.values }); // Update state with the search results
              this.setState({customerSearch: this.state.customers});

            } catch (error) {
                console.error(error);
            }
          }
          if(event && event.target && event.target.value.length === 0 && this.state.customers.length < 1){
            //this.handleLoadCustomers();

          }
        }

        const handleSelectedSeasons = async ( event, data ) => {
          console.log("SELECTED SEASONS: ", data.value);
          await this.setState({selectedSeasons: data.value});
          handleSearchCustomer({target: {value: this.state.searchString}});
        }

        const handleDeleteInventory = async () => {
            console.log("DELETE ORDER: ", this.state.idToDelete.customer.id)
            try {
                await shop.fetch(`/shop/rest/data/orders/${this.state.idToDelete.customer.id}`, {
                    method: "DELETE",
                    credentials: "include",
                });
                shop.toast("Kunde wurde zurückgesetzt, die Bestellungen werden neu geladen.");
                this.setState( { modalOpenSingle: false} ) 
                this.handleLoadCustomers();
            } catch (error) {
                console.error(error);
            }
        }

        const handleDeleteInventoryCheck = ( id ) => {
          console.log("DELETE INVENTORY CHECK");
          this.setState( {
            modalOpenSingle: true} )
          this.setState( { idToDelete: id} )
      }

        const handleDeleteWholeInventory = async () => {
          console.log("DELETE WHOLE ORDER");
          try {
            for (let customer of this.state.customers) {
              console.log("DELETE WHOLE ORDER: ", customer);
              await shop.fetch(`/shop/rest/data/orders/${customer.id}`, {
                method: "DELETE",
                credentials: "include",
              });
            }
            shop.toast("Alle Kunden wurden zurückgesetzt, die Bestellungen werden neu geladen.");
            this.setState( { modalOpen: false} ) 
            this.handleLoadCustomers();
          } catch (error) {
            console.error(error);
          }
        };

        const handleYearChange = (seasonName, year) => {
          this.setState(prevState => {
            const newSeason = { ...prevState.newSeason };
            if (newSeason.seasons[seasonName]) {
              newSeason.seasons[seasonName] = { ...newSeason.seasons[seasonName], year };
            } else {
              newSeason.seasons[seasonName] = { active: false, name: seasonName, id: seasonName, year, end: "" };
            }
            return { newSeason };
          });
        };

        const handleEndChange = (seasonName, isoEnd) => {
          const end = isoEnd ? moment(isoEnd, 'YYYY-MM-DD').format('DD.MM.YYYY') : "";
          this.setState(prevState => {
            const newSeason = { ...prevState.newSeason };
            if (newSeason.seasons[seasonName]) {
              newSeason.seasons[seasonName] = { ...newSeason.seasons[seasonName], end };
            } else {
              newSeason.seasons[seasonName] = { active: false, name: seasonName, id: seasonName, year: "", end };
            }
            return { newSeason };
          });
        };

        const saveToBackend = (seasons) => {
          const seasonNames = Object.keys(seasons);
          const Ids = seasonNames.map(name => seasons[name].id);
          const seasonActive = seasonNames.map(name => seasons[name].active);
          const years = seasonNames.map(name => seasons[name].year || "");
          const ends = seasonNames.map(name => seasons[name].end || "");
          const seasonNamesEncoded = seasonNames.map(name => encodeURIComponent(name));
          console.log("SAVE", seasonNamesEncoded, seasonActive, Ids, years, ends);
          shop.fetch('/shop/rest/config/', {
            method: 'POST',
            credentials: "include",
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              "web.kv.saison": seasonNamesEncoded.join(","),
              "web.kv.active": seasonActive.join(","),
              "web.kv.id": Ids.join(","),
              "web.kv.year": years.join(","),
              "web.kv.end": ends.join(",")
            })
          })
          .then(response => response.json())
          .then(data => { console.log('Success:', data); })
          .catch((error) => { console.error('Error:', error); });
        };

        const handleSaveAll = () => {
          shop.toast("Ihre Saison wurde erfolgreich gespeichert.");
          saveToBackend(this.state.newSeason.seasons);
          this.setState({saved: true});
        };

        const handleSave = async (seasonName, data) => {

          shop.toast( "Ihre Saison wurde erfolgreich gespeichert." )
          console.log("SAVE SEASON: ", seasonName, data.checked )
          await  this.setState(prevState => {
              let newSeason = { ...prevState.newSeason };
              console.log("PREV SEASON: ", prevState.newSeason);

                if (!newSeason.seasons[seasonName]) {
                  newSeason.seasons[seasonName] = {
                  active: data.checked,
                  name: seasonName,
                  id: seasonName,
                  year: "",
                  end: ""
                  };
                } else {
                  console.log("UPDATE SEASON: ", newSeason.seasons[seasonName], data.checked)
                  newSeason.seasons[seasonName].active = data.checked;
                }
              return { newSeason };
            });
            console.log("SAVE", this.state.newSeason);
            saveToBackend(this.state.newSeason.seasons);
          this.setState({saved: true})
        }

        const handleCreatePDF = (id) => {
          console.log("GENERATE PDF", shop.config.API, id);
          shop.toast("Ihre PDF wird generiert.");
          
            fetch(`${shop.config.API}reports/create?template=PaketBarcodes`, {
              method: "POST",
              credentials: "include",
              body: JSON.stringify({
                customer: id.customer.customerid,
                count: id.customer.extras.kartons_all,
                address: id.customer.customer,
                season: id.customer.extras.seasonName,
                totalPackages: id.customer.extras.totalPackages ? id.customer.extras.totalPackages : 0,
                orderDate: id.customer.register,
              })
            })
            .then(response => {
              response.json().then(data => {
                console.log("RESPONSE DATA: ", data);
                const rid = data.rid;
                fetch(`${shop.config.API}reports/load/pakete.pdf?rid=${rid}`, {
                  method: "GET",
                  credentials: "include",
                  headers: {
                    "Content-Type": "application/pdf"
                  }
                })
                .then(responsePDF => responsePDF.blob())
                .then(blob => {
                  console.log("BLOB: ", blob);
                  const url = URL.createObjectURL(blob);
                  console.log("URL: ", url);
                  window.open(url, "_blank");
                })
                .catch(error => {
                  shop.toast("Fehler beim anzeigen der PDF.");
                  // Handle the error
                });
              }).catch(error => {
                shop.toast("Fehler beim Verarbeiten der Antwort.");
                // Handle the error
              });
            })
            .catch(error => {
              shop.toast("Fehler beim generieren der PDF.");
              // Handle the error
            });
      }


        const handleChangeSearchString = (event) => {
          //console.log("SEARCH CHANGE: ", event.target)
          this.setState({customerSearch: []})
          for(let i = 0; i < this.state.customers.length; i++){
            //console.log("SEARCH CHANGE: ", this.state.customers[i].customer.title)
            if(this.state.customers[i].customer.title.toUpperCase().includes(event.target.value.toUpperCase()) || this.state.customers[i].customer.map_id.includes(event.target.value) || this.state.customers[i].customer.street.toUpperCase().includes(event.target.value.toUpperCase()) || this.state.customers[i].customer.pcode.includes(event.target.value) || this.state.customers[i].customer.city.toUpperCase().includes(event.target.value.toUpperCase()) || this.state.customers[i].customer.country.toUpperCase().includes(event.target.value.toUpperCase())){
              //console.log("SEARCH CHANGE CORRECT: ", this.state.customers[i])
                this.setState(prevState => ({
                  customerSearch: [...prevState.customerSearch, this.state.customers[i]]
                }));
              }
              /*if(this.state.customers[i].article_nr.includes(event.target.value) || this.state.products[i].desc.short_des.toUpperCase().includes(event.target.value.toUpperCase()) || this.state.products[i].barcode.includes(event.target.value)){
                  this.setState(prevState => ({
                      productSearch: [...prevState.customerSearch, this.state.customers[i]]
                  }));
                  //console.log("RETURN SEARCH CHANGE CORRECT", this.state.products[i])
              }*/
          }
          //console.log("SEARCH CHANGE: ", this.state.customerSearch)
          this.setState({searchString: event.target.value})
        }; 

        const handleClearSearchString = () => {
          this.setState({customerSearch: customers, searchString: "", selectedSeasons: ""});
          this.handleLoadCustomers();
      }

        const MIN_DELAY = 0
        const dropdownOptions = [{"key": "Herbst", "text": "Herbst", "value": "Herbst"},{"key": "Ostern", "text": "Ostern", "value": "Ostern"},{"key": "Weihnachten", "text": "Weihnachten", "value": "Weihnachten"}]
        const weihnachtenChecked = this.state.newSeason && this.state.newSeason.seasons["Weihnachten"] && this.state.newSeason.seasons["Weihnachten"].active && (this.state.newSeason.seasons["Weihnachten"].active == "true" || this.state.newSeason.seasons["Weihnachten"].active == true ) ? true : false;
        const osternChecked = this.state.newSeason && this.state.newSeason.seasons["Ostern"] && this.state.newSeason.seasons["Ostern"].active && (this.state.newSeason.seasons["Ostern"].active == "true" || this.state.newSeason.seasons["Ostern"].active == true ) ? true : false;
        const herbstChecked = this.state.newSeason && this.state.newSeason.seasons["Herbst"] && this.state.newSeason.seasons["Herbst"].active && (this.state.newSeason.seasons["Herbst"].active == "true" || this.state.newSeason.seasons["Herbst"].active == true ) ? true : false;
        const weihnachtenYear = this.state.newSeason && this.state.newSeason.seasons["Weihnachten"] ? this.state.newSeason.seasons["Weihnachten"].year || "" : "";
        const osternYear = this.state.newSeason && this.state.newSeason.seasons["Ostern"] ? this.state.newSeason.seasons["Ostern"].year || "" : "";
        const herbstYear = this.state.newSeason && this.state.newSeason.seasons["Herbst"] ? this.state.newSeason.seasons["Herbst"].year || "" : "";
        const weihnachtenEnd = this.state.newSeason && this.state.newSeason.seasons["Weihnachten"] ? this.state.newSeason.seasons["Weihnachten"].end || "" : "";
        const osternEnd = this.state.newSeason && this.state.newSeason.seasons["Ostern"] ? this.state.newSeason.seasons["Ostern"].end || "" : "";
        const herbstEnd = this.state.newSeason && this.state.newSeason.seasons["Herbst"] ? this.state.newSeason.seasons["Herbst"].end || "" : "";
        const toDateInputValue = (ddmmyyyy) => {
          if (!ddmmyyyy) return "";
          const m = moment(ddmmyyyy, 'DD.MM.YYYY');
          return m.isValid() ? m.format('YYYY-MM-DD') : "";
        };
        const seasonRows = [
          { name: "Weihnachten", checked: weihnachtenChecked, end: toDateInputValue(weihnachtenEnd), year: weihnachtenYear },
          { name: "Ostern",      checked: osternChecked,      end: toDateInputValue(osternEnd),      year: osternYear },
          { name: "Herbst",      checked: herbstChecked,      end: toDateInputValue(herbstEnd),      year: herbstYear },
        ];
        console.log("WEIHNACHTEN CHECKED: ", weihnachtenChecked, this.state.newSeason)
        return (
            <Fragment>
                <Modal
                  closeIcon={<Icon name="close" />}
                  open={modalOpenSingle}
                  onClose={() => {
                    this.setState( { modalOpenSingle: false} )
                  }}
                  size="tiny"
                >
                  <Modal.Header>{translate( "Zurücksetzung der Bestellung" )}</Modal.Header>
                  <Modal.Content>
                    <div className="f4 fw5 pb3 pt2">Sie sind im Begriff diese Bestellung zu löschen, möchten Sie fortfahren?</div>
                    <table>
                      <colgroup>
                        <col width="70%"/>
                        <col width="30%"/>
                      </colgroup>
                      <tbody>
                        <tr className="bt bb b--black-20">
                          <td className="pt3 pb3">
                            <Button style={{borderRadius: "25px", height: "45px"}} onClick={handleDeleteInventory}
                              primary >Bestellung löschen</Button>
                          </td>
                          <td className="tr">
                            <Button style={{borderRadius: "25px", height: "45px"}} onClick={() => {
                              this.setState( { modalOpenSingle: false} )
                            }}>Abbrechen</Button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </Modal.Content>
                </Modal>
                <Modal className="pl3 pr3"
                            closeIcon={<Icon name="close" />}
                            open={modalOpen}
                            onClose={() => {
                              this.setState( {
                                modalOpen: false} )
                            }}
                            size="tiny"
                          >
                            <Modal.Header>{translate( "Zurücksetzung der Bestellungen" )}</Modal.Header>
                            <Modal.Content className="pl3">
                            <div className="f4 fw5 pb3 pt2">Sie sind im Begriff alle {customers.length} Bestellungen aller Kunden zu löschen, möchten Sie fortfahren?</div>
                              <table>
                                <colgroup>
                                  <col width="70%"/>
                                  <col width="30%"/>
                                </colgroup>
                                <tbody>
                                  <tr className="bt bb b--black-20">
                                    <td className="pt3 pb3">
                                      <Button style={{borderRadius: "25px", height: "45px"}}  primary onClick={handleDeleteWholeInventory}>Alle Bestellungen löschen</Button>
                                    </td>
                                    <td className="tr">
                                      <Button style={{borderRadius: "25px", height: "45px"}} onClick={() => {
                                        this.setState( {
                                          modalOpen: false} )
                                      }}>Abbrechen</Button>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>

                            </Modal.Content>
                </Modal>
                <Responsive minWidth={790} >
                <section className="container pb4 pt4" >

                <div className="fr pa1"><Button style={{borderRadius: "25px"}}  primary className="mt4" onClick={() => this.props.history.push("/logout")}><Icon name={"power off"}/>Abmelden</Button></div>

                    <div className="pa4 bg-silver">
                        <div className="w-100">
                          <h1>{translate( "Saisons" )}</h1>
                          <table style={{width:"100%", borderCollapse:"collapse"}}>
                            <thead>
                              <tr>
                                <th className="tl pb2 pr3">Saison</th>
                                <th className="tl pb2 pr3">Aktiv</th>
                                <th className="tl pb2 pr3">Enddatum</th>
                                <th className="tl pb2">Jahr</th>
                              </tr>
                            </thead>
                            <tbody>
                              {seasonRows.map(s => (
                                <tr key={s.name} className="bt b--black-10">
                                  <td className="pv2 pr3"><p style={{margin:0}}>{s.name}</p></td>
                                  <td className="pv2 pr3"><Checkbox checked={s.checked} toggle onChange={(e, data) => handleSave(s.name, data)} /></td>
                                  <td className="pv2 pr3"><Input type="date" value={s.end} onChange={(e) => handleEndChange(s.name, e.target.value)} onBlur={handleSaveAll} /></td>
                                  <td className="pv2"><Input placeholder="Jahr" style={{width:"80px"}} value={s.year} onChange={(e) => handleYearChange(s.name, e.target.value)} onBlur={handleSaveAll} /></td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        <div className="db pv3 mb-2">
                        </div>

                            <h1>{translate( "Bestellungen" )}</h1>
                            <div className="pb2">
                            In folgender Tabelle schalten Sie Kunden für die erneute Bestelleingabe frei.
                            </div>
                            {/*<div className="pv2">
                              <AccountSearch loading={loading} onChange={this.handleResult}/>
                            </div>*/}
                        <div className="headerInline" >
                          <FormInput
                            Icon="search"
                            style={{ width: "75%" }}
                            className={""}
                            value={this.state.searchString}
                            onChange={handleSearchCustomer} icon="search" placeholder={translate( "Suche nach GLN / ILN" ) + " ..."}>
                          </FormInput>
                          <Dropdown style={{maxWidth:"250px", marginLeft: "10px", height: "45px", borderRadius: "25px"}}
                              placeholder={<p>{translate( "Filter nach Saison" )}</p>}
                              selection
                              fluid
                              clearable
                              value={this.state.selectedSeasons}
                              onChange={handleSelectedSeasons}
                              options={dropdownOptions}
                              />
                          <Button onClick={handleClearSearchString} style={{backgroundColor: "transparent", maxWidth:"55px"}} >
                            <Icon name="close"></Icon>
                          </Button>
                          <div className="pr2"></div>
                          <Button style={{borderRadius: "25px", height: "45px"}}  primary onClick={() => this.setState({ modalOpen: true })} >
                            Bestellungen zurücksetzen
                          </Button>
                        </div>
                        {loading && <div className="pa4 tc">
                            <Spinner size="md" type="inverted"/>
                        </div>}
                          {/*TODO: Buttons for filter Seasons */}

                        {/*<pre>{JSON.stringify( customers, null, 2 )}</pre>*/}
                        {!loading && <div className="pa3 bg-white cf cb">
                          {<TableAccounts onDelete={handleDeleteInventory} onDeleteCheck={handleDeleteInventoryCheck} onCreate={handleCreatePDF} modalOpen={modalOpenSingle} showAll={showAll} setShowAll={() => this.setState({ showAll: !showAll })} customers={customerSearch} to={shop.locationAfterLogin || this.props.to || "/home"}/>}
                                       
                            {customerSearch.length === 0 && <div className="pa3 tl">{translate( "keine Kunden gefunden" )}</div>}

                            {useMore && <div className="pv3 tc"><Button style={{borderRadius: "25px"}}  loading={loading} onClick={this.loadMore}>{translate( "mehr" )}</Button></div>}
                            <div className="fl">
                            <Button style={{borderRadius: "25px"}}  as={Link} to={"/logout"} basic size="small">{translate( "back" )}</Button>

                            </div>
                        </div>}
                        </div>
                    </div>
                </section>
                </Responsive>
                <Responsive maxWidth={789} >
                <section>
                  <div className="fr pa1"><Button style={{borderRadius: "25px"}}  primary className="mt4" onClick={() => this.props.history.push("/logout")}><Icon name={"power off"}/>Abmelden</Button></div>
                    <div className="pa4 bg-silver">
                        <div className="w-100">
                          <h1 className="pt3">{translate( "Saisons" )}</h1>
                          <div>
                            {seasonRows.map(s => (
                              <div key={s.name} className="bt b--black-10 pv2" style={{display:"flex", gap:"8px", alignItems:"flex-start"}}>
                                <div style={{flex:1}}>
                                  <p style={{margin:0, fontWeight:"bold", marginBottom:"6px"}}>{s.name}</p>
                                  <Input type="date" value={s.end} onChange={(e) => handleEndChange(s.name, e.target.value)} onBlur={handleSaveAll} style={{width:"100%"}} />
                                </div>
                                <div style={{display:"flex", flexDirection:"column", alignItems:"center", width:"70px"}}>
                                  <Checkbox checked={s.checked} toggle onChange={(e, data) => handleSave(s.name, data)} style={{marginBottom:"6px"}} />
                                  <Input placeholder="Jahr" style={{width:"70px"}} value={s.year} onChange={(e) => handleYearChange(s.name, e.target.value)} onBlur={handleSaveAll} />
                                </div>
                              </div>
                            ))}
                          </div>
                        <div className="db pv3 mb-2">
                        </div>
                        <h1 className="pt3">{translate( "Bestellungen" )}</h1>
                        <div className="pb2">
                        In folgender Tabelle schalten Sie Kunden für die erneute Bestelleingabe frei.
                        </div>
                        {/*<div className="pv2">
                            <AccountSearch loading={loading} onChange={this.handleResult}/>
                        </div> */}
                                                <div className="headerInline-mobile" >
                          <FormInput
                            Icon="search"
                            style={{ width: "75%" }}
                            className={""}
                            value={this.state.searchString}
                            onChange={handleSearchCustomer} icon="search" placeholder={translate( "Suche nach GLN / ILN" ) + " ..."}>
                          </FormInput>
<div className="pr2"></div>
                          
                        </div>
                        <div className="headerInline-mobile">
                         <Dropdown style={{maxWidth:"250px", height: "45px", borderRadius: "25px"}}
                              placeholder={<p>{translate( "Filter nach Saison" )}</p>}
                              selection
                              fluid
                              clearable
                              value={this.state.selectedSeasons}
                              onChange={handleSelectedSeasons}
                              options={dropdownOptions}
                              />
                                                        <Button onClick={handleClearSearchString} style={{backgroundColor: "transparent", maxWidth:"55px"}} >
                          <Icon name="close"></Icon>
                          </Button>
                        </div>
                        <div className="pt2 pb2">
                        <Button primary style={{borderRadius: "25px", width: "100%", height: "50px"}} onClick={() => this.setState({ modalOpen: true })} >
                            Bestellungen zurücksetzen
                          </Button>
                          <Modal className="pl3 pr3"
                            closeIcon={<Icon name="close" />}
                            open={modalOpen}
                            onClose={() => {
                              this.setState( {
                                modalOpen: false} )
                            }}
                            size="tiny"
                          >
                            <Modal.Header>{translate( "Zurücksetzung der Bestellungen" )}</Modal.Header>
                            <Modal.Content className="pl3">
                            <div className="f4 fw5 pb3 pt2">Sie sind im Begriff alle {customers.length} Bestellungen aller Kunden zu löschen, möchten Sie fortfahren?</div>
                              <table>
                                <colgroup>
                                  <col width="70%"/>
                                  <col width="30%"/>
                                </colgroup>
                                <tbody>
                                  <tr className="bt bb b--black-20">
                                    <td className="pt3 pb3">
                                      <Button primary style={{borderRadius: "25px"}} onClick={handleDeleteWholeInventory}>Alle Bestellungen löschen</Button>
                                    </td>
                                    <td className="tr">
                                      <Button style={{borderRadius: "25px"}} onClick={() => {
                                        this.setState( {
                                          modalOpen: false} )
                                      }}>Abbrechen</Button>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>

                            </Modal.Content>
                            </Modal>
                        </div>
                        {loading && <div className="pa4 tc">
                            <Spinner size="md" type="inverted"/>
                        </div>}
                        {/*<pre>{JSON.stringify( customers, null, 2 )}</pre>*/}
                        {!loading && <div className="pa3 bg-white cf cb">
                          {<TableAccounts onDelete={handleDeleteInventory} onDeleteCheck={handleDeleteInventoryCheck} onCreate={handleCreatePDF} modalOpen={modalOpenSingle} showAll={showAll} setShowAll={() => this.setState({ showAll: !showAll })} customers={customerSearch} to={shop.locationAfterLogin || this.props.to || "/home"}/>}
                                       
                            {customerSearch.length === 0 && <div className="pa3 tl">{translate( "keine Kunden gefunden" )}</div>}

                            {useMore && <div className="pv3 tc"><Button  style={{borderRadius: "25px"}} loading={loading} onClick={this.loadMore}>{translate( "mehr" )}</Button></div>}
                            <div className="fl pt2">
                            <Button as={Link} to={"/logout"} basic style={{borderRadius: "25px"}} size="small">{translate( "back" )}</Button>

                            </div>
                        </div>}
                        </div>
                    </div>
					</section>

                </Responsive>
            </Fragment>
        );
    }
}


class AccountSearch extends Component {

    state = {
      value  : "",
      error  : false,
      loading: false
    }
  
    search( value, page = 1, count = 24 ) {
      this.setState( { loading: true } )
      let start = (page - 1) * count
      console.log( "SEARCH", value )
      let modifiedValue = value
      if(shop.config.USE_OLD_SEARCH){
        modifiedValue = `%${value}%`
      }
      shop.fetch( `/shop/rest/data/customers/search?title=${encodeURIComponent( `%${modifiedValue}%` )}&count=${count}&start=${start}` ) // pre-urlencoded % = %25
        .then( data => {
          console.log( { data } )
          const { size, result } = data
          this.props.onChange && this.props.onChange( { size, customers: result, query: value } )
          this.setState( { loading: false } )
        } )
        .catch( error => {
          this.setState( { error } )
          shop.toast( translate( "toast.SESSION_CLOSED" ) )
          console.error( "Error fetching customers", error )
        } )
    }
  
    reset = () => {
      this.props.onChange && this.props.onChange( { size: false, customers: [] } )
      this.setState( { value: "" } )
    }
  
    handleChange = e => {
      let value = e.target.value
      this.setState( { value } )
      this.search( value )
      /*if ( value && value.length >= 3 ) {
        this.search( value )
      } else {
        this.props.onChange && this.props.onChange( { size: false, customers: [] } )
      }*/
    }
  
    render() {
      const { value, loading, error } = this.state
  
      return (
        <div className="AccountSearch">
          <Input className="w-50 mr2" value={value} icon="search" loading={loading} placeholder={translate("Kunde, PLZ oder Name..")} onChange={this.handleChange}/>
          <Button className="dib " style={{align: "right"}} onClick={this.reset} basic icon={"close"}/>
          {error && <Redirect to={"/login/"}/>}
        </div>
      )
    }
  }
  
  
  const TableAccounts = ( { to, onDelete, onDeleteCheck, onCreate, customers, modalOpen, showAll, setShowAll } ) => (
    <Fragment>
      <Responsive minWidth={790} >
      <Table compact>
        {console.log("CUSTOMERS TABLE ACCOUNTS: ", customers)}
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>GLN / ILN</Table.HeaderCell>
            <Table.HeaderCell>Name</Table.HeaderCell>
            <Table.HeaderCell>Saison</Table.HeaderCell> 
            <Table.HeaderCell>Baustein</Table.HeaderCell> 
            <Table.HeaderCell>Adresse</Table.HeaderCell>
            <Table.HeaderCell>{translate( "Registriert" )}</Table.HeaderCell>
            <Table.HeaderCell>Aktionen</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {showAll && customers.map( customer => {
              return (
                <Table.Row key={customer.map_id+customer.customerid}>
                  {/*console.log("CUSTOMER: ", customer.register)*/}
                  <Table.Cell>{customer.customerid}</Table.Cell>
                  <Table.Cell>{customer.customer.title}</Table.Cell>
                  <Table.Cell>{customer.extras.bausteinSeason}</Table.Cell>
                  <Table.Cell>{customer.positions && customer.positions[0] && customer.positions[0].desc}</Table.Cell>
                  <Table.Cell>{customer.customer.street}<br/>{customer.customer.pcode}&nbsp;{customer.customer.city}<br/>{customer.customer.country}</Table.Cell>
                  <Table.Cell>{moment(customer.register).format('DD.MM.YYYY')}</Table.Cell>
                  <Table.Cell>
                  <div className="tr pa2">
                  <Button style={{minWidth:"150px", borderRadius: "25px", height: "40px"}} onClick={() => {
                    onDeleteCheck( { customer } )
                  }} size={"tiny"} primary>{translate( "Zurücksetzen " )}</Button></div>
                  </Table.Cell>
                </Table.Row>
              )
            
              
          } )}
          {!showAll && customers.slice(0, 50).map( customer => {
            //console.log("CUSTOMER: ", customer)
              return (
                <Table.Row key={customer.map_id+customer.customerid}>
                  {/*console.log("CUSTOMER: ", customer.register)*/}
                  <Table.Cell>{customer.customerid}</Table.Cell>
                  <Table.Cell>{customer.customer.title}</Table.Cell>
                  <Table.Cell>{customer.extras.bausteinSeason}</Table.Cell>
                  <Table.Cell>{customer.positions && customer.positions[0] && customer.positions[0].desc}</Table.Cell>
                  <Table.Cell>{customer.customer.street}<br/>{customer.customer.pcode}&nbsp;{customer.customer.city}<br/>{customer.customer.country}</Table.Cell>
                  <Table.Cell>{moment(customer.register).format('DD.MM.YYYY')}</Table.Cell>
                  <Table.Cell>
                    <div className="tr pa2">
                  <Button style={{minWidth:"150px", borderRadius: "25px", height: "40px"}} onClick={() => {
                    onDeleteCheck( { customer } )
                  }} size={"tiny"} primary>{translate( "Zurücksetzen " )}</Button></div>
                  </Table.Cell>
                </Table.Row>
              )
            
          } )}
        </Table.Body>
      </Table>
      {!showAll && <div className="tc"><Button style={{borderRadius: "25px"}}  className="tc" onClick={() => setShowAll()} >Alle anzeigen...</Button></div>}
      </Responsive>
      <Responsive maxWidth={789} >
        {/*console.log("CUSTOMERS TABLE ACCOUNTS: ", customers)*/}
          {!showAll && customers.slice(0, 50).map( customer => {
              return (
                  <table key={customer.map_id}>
                    <colgroup>
                      <col width="50%"/>
                      <col width="50%"/>
                    </colgroup>
                    <tbody>
                    <tr className="pb2 pt2">
                      <td className="pb2 bb">GLN / ILN</td>
                      <td className="pb2 tr bb b">{customer.customerid}</td>
                    </tr>
                    <tr className="">
                      <td className="pb2 bb">Name</td>
                      <td className="pb2 tr bb b">{customer.customer.title}</td>
                    </tr>
                    <tr className="">
                      <td className="pb2 bb">Saison</td>
                      <td className="pb2 tr bb b">{customer.extras.bausteinSeason}</td>
                    </tr>
                    <tr className="">
                      <td className="pb2 bb">Adresse</td>
                      <td className="pb2 tr bb b">{customer.customer.street}<br/>{customer.customer.pcode}&nbsp;{customer.customer.city}<br/>{customer.customer.country}</td>
                    </tr>
                    <tr className="">
                      <td className="pb2 bb">Registriert</td>
                      <td className="pb2 tr bb b">{moment(customer.register).format('DD.MM.YYYY')}</td>
                    </tr>

                    <tr className="">
                      <td className="pb2 bb bw3">Aktionen</td>
                      <td className="pb2 tr bb b bw3">
                        <Button style={{minWidth:"150px", borderRadius: "25px", height: "40px"}} onClick={() => {
                          onDeleteCheck( { customer } )
                        }} size={"tiny"} primary>{translate( "Zurücksetzen " )}</Button>

                      </td>
                    </tr>
                    
                    </tbody>
                  </table>
              )
          } )}
                    {showAll && customers.map( customer => {
              return (
                  <table key={customer.map_id}>
                    <colgroup>
                      <col width="50%"/>
                      <col width="50%"/>
                    </colgroup>
                    <tbody>
                    <tr className="pb2 pt2">
                      <td className="pb2 bb">GLN / ILN</td>
                      <td className="pb2 tr bb b">{customer.customerid}</td>
                    </tr>
                    <tr className="">
                      <td className="pb2 bb">Name</td>
                      <td className="pb2 tr bb b">{customer.customer.title}</td>
                    </tr>
                    <tr className="">
                      <td className="pb2 bb">Saison</td>
                      <td className="pb2 tr bb b">{customer.extras.bausteinSeason}</td>
                    </tr>
                    <tr className="">
                      <td className="pb2 bb">Adresse</td>
                      <td className="pb2 tr bb b">{customer.customer.street}<br/>{customer.customer.pcode}&nbsp;{customer.customer.city}<br/>{customer.customer.country}</td>
                    </tr>
                    <tr className="">
                      <td className="pb2 bb">Registriert</td>
                      <td className="pb2 tr bb b">{moment(customer.register).format('DD.MM.YYYY')}</td>
                    </tr>
                    <tr className="">
                      <td className="pb2 bb bw3">Aktionen</td>
                      <td className="pb2 tr bb b bw3">
                        <Button style={{minWidth:"150px", borderRadius: "25px", height: "40px"}} onClick={() => {
                          onDeleteCheck( { customer } )
                        }} size={"tiny"} primary>{translate( "Zurücksetzen " )}</Button>
                      </td>
                    </tr>
                    
                    </tbody>
                  </table>
              )
          } )}
          {!showAll && <div className="tc"><Button style={{borderRadius: "25px"}} onClick={() => setShowAll()} >Alle anzeigen...</Button></div>}
          </Responsive>
    </Fragment>
  )

export default ReturnAdminPage;


// WEBPACK FOOTER //
// ./src/theme/braunsheitmannShop/pages/returnCheckout/ReturnAdminPage.js